export const formatDateToMadridTime = (isoDate, onlyDate = false, sqlFormat = false) => {
  const date = new Date(isoDate);

  // Define the formatter for Spain, Madrid time zone
  const options = {
    year: sqlFormat ? "numeric" : "2-digit",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    timeZone: "Europe/Madrid",
    hour12: false, // Use 24-hour format
  };

  const formatter = new Intl.DateTimeFormat("es-ES", options);

  // Format the date and time and remove the comma
  const formattedParts = formatter.formatToParts(date);
  const day = formattedParts.find(part => part.type === "day").value;
  const month = formattedParts.find(part => part.type === "month").value;
  const year = formattedParts.find(part => part.type === "year").value;
  const hour = formattedParts.find(part => part.type === "hour").value;
  const minute = formattedParts.find(part => part.type === "minute").value;
  const second = formattedParts.find(part => part.type === "second").value;

  // Construct the desired format
  let dmY = `${day}/${month}/${year}`
  if (sqlFormat) {
    dmY = `${year}-${month}-${day}`
  }
  if (onlyDate) {
    return `${dmY}`;
  } else {
    return `${dmY} ${hour}:${minute}:${second}`;
  }
};

export const formatDuration = (seconds) => {
  // Calculate hours, minutes, and remaining seconds
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = seconds % 60;

  // Format the result as "99h 99m 99s"
  return `${hours}h ${minutes}m ${remainingSeconds}s`;
};

export const formatDateToUTCMadrid = (isoDate, onlyDate = false) => {
  const date = new Date(isoDate);

  // Define the formatter for Spain, Madrid time zone
  const options = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    timeZone: "Europe/Madrid",
    hour12: false, // Use 24-hour format
  };

  const formatter = new Intl.DateTimeFormat("es-ES", options);

  // Format the date and time and remove the comma
  const formattedParts = formatter.formatToParts(date);
  const day = formattedParts.find(part => part.type === "day").value;
  const month = formattedParts.find(part => part.type === "month").value;
  const year = formattedParts.find(part => part.type === "year").value;
  const hour = formattedParts.find(part => part.type === "hour").value;
  const minute = formattedParts.find(part => part.type === "minute").value;
  const second = formattedParts.find(part => part.type === "second").value;

  if (onlyDate) {
    return `${year}-${month}-${day}`;
  } else {
    return `${year}-${month}-${day}T${hour}:${minute}:${second}`;
  }
};

export const formatBytes = (bytes, decimals = 2) => {
  if (bytes === 0) return "0 Bytes";
  const k = 1024;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(decimals))} ${sizes[i]}`;
};

export const formatAccessLevels = (id) => {
  if (id == 1){
    return "Administrador";
  } else if (id == 2) {
    return "Bàsic";
  } else {
    return "-";
  }
};

export const formatPushNotificationActions = (id) => {
  if (id == 'open-news'){
    return "Obrir notícia";
  } else {
    return "-";
  }
};

export const formatDaysOfWeek = (dayCode) => {
  if (dayCode == 'monday'){
    return "Dilluns";
  } else if (dayCode == 'tuesday') {
    return "Dimarts";
  } else if (dayCode == 'wednesday') {
    return "Dimecres";
  } else if (dayCode == 'thursday') {
    return "Dijous";
  } else if (dayCode == 'friday') {
    return "Divendres";
  } else if (dayCode == 'saturday') {
    return "Dissabte";
  } else if (dayCode == 'sunday') {
    return "Diumenge";
  } else {
    return "-";
  }
};

